import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { getRestauranteActual } from "../api/public";
import fondo from "../assets/fondo-restaurante.jpg";

export default function LoginPage() {
  const { iniciarSesion } = useAuth();
  const navigate = useNavigate();
  const [correo, setCorreo] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [error, setError] = useState("");
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const cargarLogo = async () => {
      try {
        const restaurante = await getRestauranteActual();
        console.log('Restaurante obtenido en LoginPage:', restaurante);
        if (restaurante?.logo) {
          const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
          const logoUrl = `${API_URL}${restaurante.logo}?t=${Date.now()}`;
          console.log('Logo URL en LoginPage:', logoUrl);
          setLogo(logoUrl);
        } else {
          console.log('No se encontró logo en el restaurante');
        }
      } catch (error) {
        console.error('Error cargando logo en LoginPage:', error);
      }
    };

    cargarLogo();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await iniciarSesion({ correo, contrasenia });
      navigate("/dashboard");
    } catch (err) {
      setError(err);
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${fondo})` }}
    >
      <form
          onSubmit={handleSubmit}
          className="bg-amber-900/50 p-8  rounded-3xl shadow-2xl w-96 max-w-full backdrop-blur-md"
        >
        {/* Logo del restaurante */}
        <div className="flex justify-center mb-6">
          {logo && <img src={logo} alt="Logo Restaurante" className="h-40 w-auto" />}
        </div>

        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
          Iniciar Sesión
        </h2>

        <input
          type="email"
          placeholder="Correo electrónico"
          className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
        />

        <input
          type="password"
          placeholder="Contraseña"
          className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
          value={contrasenia}
          onChange={(e) => setContrasenia(e.target.value)}
        />

        {error && (
          <p className="text-red-500 text-sm mb-4 text-center">{error}</p>
        )}

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
        >
          Entrar
        </button>

        <p className="text-sm text-center text-black-500 mt-4">
          ¿Olvidaste tu contraseña?{" "}
          <a href="/recuperar-contraseña" className="text-blue-500 hover:underline">
            Recuperar
          </a>
        </p>
      </form>
    </div>
  );
}
